import { NoteIcon } from '@phosphor-icons/react';
import { Badge, Loader, Tabs } from '@mantine/core';
import { useMemo } from 'react';
import useSalesOrderNotes from '@/features/finance/sales-orders/hooks/useSalesOrderNotes.tsx';

export default function SalesOrderNotesTab({
  salesOrderId,
}: {
  salesOrderId: string;
}) {
  const notesQuery = useSalesOrderNotes(salesOrderId);

  const notesCount = useMemo(
    () => (notesQuery.data?.notes ?? []).length,
    [notesQuery.data],
  );

  return (
    <Tabs.Tab
      value="notes"
      title="Notes"
      aria-label="Notes"
      leftSection={<NoteIcon size={14} />}
      rightSection={
        notesQuery.isLoading ? (
          <Loader size="xs" />
        ) : (
          <Badge size="xs" color={notesCount ? 'blue' : 'gray'}>
            {notesCount}
          </Badge>
        )
      }
    >
      Notes
    </Tabs.Tab>
  );
}
